/* eslint-disable */
import React from "react";

import App from "./App";
import keycloak, { keycloakInitOptions } from "./config/keycloak";

import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { ReactKeycloakProvider } from "@react-keycloak/web";

ReactDOM.render(
  <ReactKeycloakProvider
    authClient={keycloak}
    initOptions={keycloakInitOptions}
  >
    <Router>
      <App />
    </Router>
  </ReactKeycloakProvider>,
  document.getElementById("root")
);
